//@ts-nocheck
import { Equal, LogIn, X } from "lucide-react";
import ProfileButton from "../ProfileButton";
import NotificationButton from "../NotificationButton";
import { IUser } from "@/integration/user/interfaces/IUser.ts";
import { useChat } from "@/context/ChatProvider";
import MenuDawable from "@/components/application/LeftBar/MenuDawable.tsx";
import LogoToolBar from "@/assets/svgComponets/LogoToolbar.tsx";
import useUser from "@integration/user/hooks/useUser.ts";
import { useNavigate } from "react-router-dom";
import useAuth from "@integration/user/hooks/useAuth.ts";
import { motion } from "framer-motion";
import CommandMenu from "../ComandMenu";

interface ToolBarProps {
  user: IUser | null;
  onToggleSidebar: () => void;
  isToggleSidebar: boolean;
}

export default function ToolBar({ onToggleSidebar, isToggleSidebar }: ToolBarProps) {
  const { toggleChat, isOpen: isChatOpen } = useChat();
  const navigate = useNavigate();
  const { userAuth, avatarFile } = useUser();
  const { isAuthenticated } = useAuth();

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className="relative bg-gradient-to-r from-gray-900 to-gray-800 h-20 sm:h-20 w-full flex items-center px-6 border-b border-gray-600/50"
    >

      <motion.button
        onClick={onToggleSidebar}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        className="hidden md:flex   items-center mr-5 justify-center w-10 h-10 bg-gradient-to-b from-gray-700/80 to-gray-800/80 border border-gray-600/50 hover:border-red-500/50 rounded-xl relative overflow-hidden shadow-md hover:shadow-lg transition-all duration-300"
      >
        <Equal
          size={35}
          strokeWidth={1.2}
          className={`absolute transition-all duration-300 ${isToggleSidebar ? "opacity-0 scale-0" : "opacity-100 scale-100"} text-white`}
        />

        <X
          size={35}
          strokeWidth={1.2}
          className={`absolute transition-all duration-300 ${isToggleSidebar ? "opacity-100 scale-100" : "opacity-0 scale-0"} text-white`}
        />
      </motion.button>

      <div className="md:hidden mt-2">
        <MenuDawable />
      </div>

      <div className="flex w-full justify-between items-center">
        <motion.div
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="cursor-pointer"
        >
          <LogoToolBar  />
        </motion.div>

        <div className=" flex items-center md:gap-4 ml-3">

          {isAuthenticated ? (
            <>
              <CommandMenu />
              <motion.div
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <ProfileButton
                  onClick={() => navigate(`/pro/${userAuth?.nick}`)}
                  avatar={avatarFile?.url ?? null}
                  username={userAuth?.nick || userAuth?.name}
                />
              </motion.div>
              <div className="hidden md:flex items-center gap-4">
                <NotificationButton />
                {/**   <CircleButton
                 onClick={toggleChat}
                 size="md"
                 borderColor="gray-100"
                 isActive={isChatOpen}
                 >
                 <MessageCircle size={28} />
                 </CircleButton> */}
              </div>
            </>
          ) : (
            <motion.button
              onClick={() => navigate('/auth')}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="flex items-center  ml-4 gap-2 px-3 py-1 bg-gradient-to-b from-gray-700/80 to-gray-800/80 border border-gray-600/50 hover:border-red-500/50 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 text-white"
            >
              <LogIn size={15} />
              <span>Login</span>
            </motion.button>
          )}

        </div>

      </div>



    </motion.header>
  );
}
